module.exports = __webpack_public_path__ + "static/media/Dr. Nabil Nouman.0b65d89d.jpg";